<template>
    <v-form @submit.prevent="upsertTimeOff" ref="form">
        <v-card dense style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold" v-if="mode=='Add'">Add Personal Time Off</span>
                <span class="font-weight-bold" v-else>Edit Personal Time Off</span>
                <v-spacer></v-spacer>
                <help-link appId="attendance" pageId="timeoff-page" color="black"></help-link>
                <v-btn icon @click.native="closeDialog">
                <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{ errorMessage }}
            </v-alert>  
            <v-card-text dense>
                <v-alert v-if="status==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline style="margin:0px 20px 10px 20px;">
                    This is already approved. Clicking Save will update back to For Review.
                </v-alert>  
                <v-alert v-if="!validInputHours" :value="true" color="error" icon="error" outline style="margin:0px 20px 10px 20px;">
                    Requested total hours exceeds available balance.
                </v-alert>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">  
                        <v-layout row>
                            <v-flex xs12 sm6 style="margin-right:15px;">
                                <v-menu v-model="menuTransDate" :close-on-content-click="false" :nudge-right="40"
                                lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field label="Start Date" v-model="transDate" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                                </template>
                                <v-date-picker no-title v-model="transDate" :allowed-dates="allowedDates" @input="onTransDateChange"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6 style="margin-left:15px;">
                                <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40"
                                lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field label="End Date" v-model="endDate" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                                </template>
                                <v-date-picker no-title v-model="endDate" :allowed-dates="allowedDatesForEndDate" @input="onEndDateSelected"></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12 sm12>
                                <v-autocomplete
                                    label="Type"
                                    v-model="leaveTypeId"
                                    :disabled="disabled||!leavesBalancesLoaded"
                                    :items="leaves_allocation"
                                    :rules="[rules.required]"
                                    chips
                                    color="primary lighten-2"
                                    item-text="leaveName"
                                    item-value="leaveTypeId"
                                    @change="formatHours" 
                                    >
                                    <template v-slot:selection="data">
                                        <v-chip :selected="data.selected" class="chip--select-multi">
                                            {{ data.item.leaveName }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                        </template>
                                        <template v-else>
                                            <v-list-tile-content>
                                                <v-list-tile-title v-html="data.item.leaveName"></v-list-tile-title>
                                                <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row>  
                            <v-flex xs12 sm12>
                                <v-text-field 
                                    label="Hours per day"
                                    v-model="hours" 
                                    :rules="[rules.required, rules.valid_hours]" 
                                    type="number" min="0" maxlength="8" step="0.25"
                                    @blur="formatHours">
                                </v-text-field>  
                                <div style="margin-top:-18px;" class="text-xs-right">
                                    <small>In decimal format. (1.5 = 1hour 30mins)</small>
                                </div>
                            </v-flex>      
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm12>
                                <div style="margin:-5px 0px 15px 0px;">
                                    <v-switch
                                    v-model="includeWeekends"
                                    label="Include weekends"
                                    color="primary"
                                    persistent-hint
                                    @change="updateTotalHours"
                                    :hint="includeWeekends?'Will include weekends if within selected date range':'Will not include weekends if within selected date range'"
                                    ></v-switch> 
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row style="margin-top:10px;">
                            <v-flex xs3>Total Hours:</v-flex>
                            <v-flex xs9>
                                {{ totalRequestedHours }}
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="showComment" style="margin-top:30px;">  
                            <v-flex xs12 sm12 style="margin-top:-25px;">
                                <v-textarea v-model="remarks" label="Comments" rows="1" color="primary"></v-textarea>
                            </v-flex>      
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions style="height:45px">
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Comment">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn color="primary" type="submit" :loading="loading" :disabled="disabled">
                    <span v-if="mode=='Add'">Save</span>
                    <span v-if="mode=='Edit'">Update</span>
                </v-btn>
                <v-btn v-if="mode=='Add'" @click="clearForm" :disabled="disabled">Clear</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
import timeOffsApi from '@/api/timeoffs'
import leavesAllocationApi from '@/api/leavesallocation'
import commonfn from '@/common/functions'

export default {
    data() {
        return {
            error: false,
            errorMessage: '',
            transDate: null,
            endDate: null,
            workShift: '',
            disabled: false,
            loading: false,
            showComment: false,
            leavesBalancesLoaded: false,
            rules: {
                required: value => !!value || 'Required.',
                valid_hours: value => value > 0 || 'Should be greater than zero'
            },        
            remarks: '',
            status: '',
            mode: '',
            duration: '',
            leaveTypeId: null,
            hours: null,
            totalRequestedHours: 0,
            timeOffId: null,
            leaves_allocation: [],
            validInputHours: true,
            menuTransDate: false,
            menuEndDate: false,
            includeWeekends: false,
            cutoff: null
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink')
    },
    methods: {
        allowedDates(val) {
            return (this.$moment(this.cutoff.cutoffStart).format('YYYY-MM-DD') <= this.$moment(val).format('YYYY-MM-DD') &&
                this.$moment(this.cutoff.cutoffEnd).format('YYYY-MM-DD') >= this.$moment(val).format('YYYY-MM-DD'))
        },
        allowedDatesForEndDate(val) {
            const isAfterOrSameTransDate = this.$moment(val).isSameOrAfter(this.transDate, 'day');
            const isWithinCutoff = this.$moment(val).isBetween(this.cutoff.cutoffStart, this.cutoff.cutoffEnd, 'day', '[]');
            return isAfterOrSameTransDate && isWithinCutoff;
        },
        onTransDateChange() {
            this.menuTransDate = false
            this.endDate = this.transDate
            this.getAvailableLeaves()
            this.updateTotalHours()
        },
        formatHours() {
            this.validInputHours = true
            if (this.hours > 8) this.hours = 8

            //see formatNumber in num_format.js
            if (this.hours) this.hours = parseFloat(this.hours).toFixed(2)

            this.updateTotalHours()
        },
        onEndDateSelected(val) {
            this.endDate = val;
            this.menuEndDate = false; // close the date picker manually
            this.updateTotalHours();
        },
        updateTotalHours() {
            if (!this.transDate || !this.endDate || !this.hours) return;

            const start = this.$moment(this.transDate);
            const end = this.$moment(this.endDate);
            const dailyHours = parseFloat(this.hours);

            let total = 0;
            let current = start.clone();

            while (current.isSameOrBefore(end, 'day')) {
                const day = current.day(); // 0 = Sunday, 6 = Saturday

                // Respect includeWeekends flag
                if (this.includeWeekends || (day !== 0 && day !== 6)) {
                    total += dailyHours;
                }

                current.add(1, 'day');
            }

            this.totalRequestedHours = total;

            // Format number to 2 decimals if total exists
            if (this.totalRequestedHours) {
                this.totalRequestedHours = parseFloat(this.totalRequestedHours).toFixed(2);
            }

            const selected = this.leaves_allocation.find(
                x => x.leaveTypeId === this.leaveTypeId
            );

            let balance = 0;
            if (selected && typeof selected.balanceHours !== 'undefined' && selected.balanceHours !== null) {
                balance = selected.balanceHours;
            }

            this.validInputHours = (balance === -1 || total <= balance);
        },
        async setParams(data) {
            this.mode = data.mode
            this.cutoff = data.cutoff
            this.clearForm()
            this.workShift = data.workShift
        },
        async getAvailableLeaves() {
            this.leavesBalancesLoaded = false
            this.disabled = true
            try {
                this.leaves_allocation = []
                const response = await leavesAllocationApi.getAvailable(this.transDate)
                if (response && response.status === 200) {
                    response.data.items.forEach(item => {
                    var balanceHours = item.earnedHours > item.balanceHours ? item.balanceHours : item.earnedHours
                    this.leaves_allocation.push({
                        leaveTypeId: item.leaveTypeId,
                        balanceHours: balanceHours,
                        leaveName: item.earnedHours === -1 ? item.leaveName : `${item.leaveName} (${balanceHours} hrs available)`
                    })
                    })
                    this.leavesBalancesLoaded = true
                }
            }catch (error){
                this.error = true
                this.errorMessage = error
            }
            this.disabled = false
        },
        async upsertTimeOff() {
            try {
                if (this.$refs.form.validate() && this.validInputHours) {
                    this.loading = true
                    this.disabled = true
                    const data = {
                        timeOffId: this.timeOffId,
                        transDate: this.transDate,
                        endDate: this.endDate,
                        hours: this.hours,
                        type: this.leaveTypeId,
                        includeWeekends: this.includeWeekends,
                        remarks: this.remarks
                    }
                    const response = await timeOffsApi.add(data)
                    if (response && response.status === 200) {
                        this.clearForm()
                        this.closeDialog()
                        this.$emit('send', null)
                    }
                    this.loading = false
                    this.disabled = false
                }
            } catch (error) {
                this.error = true
                this.errorMessage = error
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.validInputHours = true
            this.leavesBalancesLoaded = false
            this.totalRequestedHours = null
        },
        closeDialog() {
            this.$emit('update:dialogPTO', false)
        }
    },
    created() {
        this.commonfn = commonfn
    }
}
</script>
<style scoped>
.form-content {
    padding:10px 25px 0px 25px;
}
</style>